export class CompanyClassLength {
  classB: number;
  classC: number;

  constructor(classB: number, classC: number) {
    this.classB = classB;
    this.classC = classC;
  }
}
